module.exports = "/_next/static/images/OgStateOfPersonalizationReport2021-67ce43f22c1ecc3c49dff1e24fc50cf6.png";